import exportimages from "../assets/images/exportImages";
import { PRIVILEGES } from "./privileges";

export const LANGUAGES = [
  { key: "id", display_value: "Bahasa Indonesia - Indonesian" },
  { key: "msa", display_value: "Bahasa Melayu - Malay" },
  { key: "ca", display_value: "CatalÃ  - Catalan" },
  { key: "cs", display_value: "ÄŒeÅ¡tina - Czech" },
  { key: "da", display_value: "Dansk - Danish" },
  { key: "de", display_value: "Deutsch - German" },
  { key: "en", display_value: "English US (Default)" },
  { key: "en-gb", display_value: "English UK - British English" },
  { key: "es", display_value: "EspaÃ±ol - Spanish" },
  { key: "eu", display_value: "Euskara - Basque (beta)" },
  { key: "fil", display_value: "Filipino" },
  { key: "fr", display_value: "FranÃ§ais - French" },
  { key: "ga", display_value: "Gaeilge - Irish (beta)" },
  { key: "gl", display_value: "Galego - Galician (beta)" },
  { key: "hr", display_value: "Hrvatski - Croatian" },
  { key: "it", display_value: "Italiano - Italian" },
  { key: "hu", display_value: "Magyar - Hungarian" },
  { key: "nl", display_value: "Nederlands - Dutch" },
  { key: "no", display_value: "Norsk - Norwegian" },
  { key: "pl", display_value: "Polski - Polish" },
  { key: "pt", display_value: "PortuguÃªs - Portuguese" },
  { key: "ro", display_value: "RomÃ¢nÄƒ - Romanian" },
  { key: "sk", display_value: "SlovenÄina - Slovak" },
  { key: "fi", display_value: "Suomi - Finnish" },
  { key: "sv", display_value: "Svenska - Swedish" },
  { key: "vi", display_value: "Tiáº¿ng Viá»‡t - Vietnamese" },
  { key: "tr", display_value: "TÃ¼rkÃ§e - Turkish" },
  { key: "el", display_value: "Î•Î»Î»Î·Î½Î¹ÎºÎ¬ - Greek" },
  { key: "bg", display_value: "Ð‘ÑŠÐ»Ð³Ð°Ñ€ÑÐºÐ¸ ÐµÐ·Ð¸Ðº - Bulgarian" },
  { key: "ru", display_value: "Ð ÑƒÑÑÐºÐ¸Ð¹ - Russian" },
  { key: "sr", display_value: "Ð¡Ñ€Ð¿ÑÐºÐ¸ - Serbian" },
  { key: "uk", display_value: "Ð£ÐºÑ€Ð°Ñ—Ð½ÑÑŒÐºÐ° Ð¼Ð¾Ð²Ð° - Ukrainian" },
  { key: "he", display_value: "×¢Ö´×‘Ö°×¨Ö´×™×ª - Hebrew" },
  { key: "ur", display_value: "Ø§Ø±Ø¯Ùˆ - Urdu (beta)" },
  { key: "ar", display_value: "Ø§Ù„Ø¹Ø±Ø¨ÙŠØ© - Arabic" },
  { key: "fa", display_value: "ÙØ§Ø±Ø³ÛŒ - Persian" },
  { key: "mr", display_value: "à¤®à¤°à¤¾à¤ à¥€ - Marathi" },
  { key: "hi", display_value: "à¤¹à¤¿à¤¨à¥à¤¦à¥€ - Hindi" },
  { key: "bn", display_value: "à¦¬à¦¾à¦‚à¦²à¦¾ - Bangla" },
  { key: "gu", display_value: "àª—à«àªœàª°àª¾àª¤à«€ - Gujarati" },
  { key: "ta", display_value: "à®¤à®®à®¿à®´à¯ - Tamil" },
  { key: "kn", display_value: "à²•à²¨à³à²¨à²¡ - Kannada" },
  { key: "th", display_value: "à¸ à¸²à¸©à¸²à¹„à¸—à¸¢ - Thai" },
  { key: "ko", display_value: "í•œêµ­ì–´ - Korean" },
  { key: "ja", display_value: "æ—¥æœ¬èªž - Japanese" },
  { key: "zh-cn", display_value: "ç®€ä½“ä¸­æ–‡ - Simplified Chinese" },
  { key: "zh-tw", display_value: "ç¹é«”ä¸­æ–‡ - Traditional Chinese" },
];

export const USER_TYPE = {
  USER: "User",
  ADMIN: "Admin",
  RESELLER: "Reseller",
  SUPER_ADMIN: "Bond-Admin",
};

export const NO_CLIENT_ID = "00000000-0000-0000-0000-000000000000";

export const RESELLER_USER_TYPE = {
  RESELLER_CLIENT_USER_ROLE_KEY: "BONDAI_AP_CLIENT_ADMIN",
};

//RegEx Patterns
export const REGEX_PATTERN_EMAIL = () =>
  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/;
export const REGEX_PATTERN_NUMBER = () =>
  /^(\+?\d{1,3}[- ]?)?\d{10}$|^\d{5}[- ]?\d{6}$/;
export const REGEX_PATTERN_WHITESPACE = () =>
  /^[A-Za-z0-9!@#$%^&*().,<>{}\[\]<>?_=+\-|;:'"\/]+$/;
export const REGEX_PATTERN_ALPHANUMARIC_UNDERSCORE = () =>
  /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_ -]+$/;
export const REGEX_PATTERN_AT_LEAST_ONE_LETTER_ALPHANUMARIC_SPECIAL_CHAR = () =>
  /^(?=.*[a-zA-Z])(?!.*[\n\r])[a-zA-Z0-9_@#$%^&*()\-+=!~`[\]{}|:;"'<>,.?/\\ ]+$/;
export const REGEX_PATTERN_ALPHANUMARIC_FEW_SPECIAL_CHAR = () =>
  /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9- _,.'&]+$/;
export const REGEX_PATTERN_ALPHANUMARIC_OPTIONAL_SPECIAL_CHAR = () =>
  /^(?=.*[a-zA-Z]).*$/;
export const REGEX_PATTERN_LINK = () =>
  /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[\w./#?&=-]*)?$/i;
export const REGEX_PATTERN = () => /^(?=.*[a-zA-Z])[\s\S]+$/;

export const PASSWORD_POLICY = (value) => {
  let MIN_LENGTH = 12;
  let MAX_LENGTH = 16;
  let REGEX_PATTERN =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-=_+{}[\]:;"'<>,.?/~`|\\/])[a-zA-Z\d!@#$%^&*()\-=_+{}[\]:;"'<>,.?/~`|\\/]{12,}$/;
  let errorStatus = false;
  let errorMessage = "";
  if (value.length > MAX_LENGTH) {
    errorStatus = true;
    errorMessage = "Password should be in between 12 to 16 characters.";
  } else if (value.length === 0) {
    errorStatus = true;
    errorMessage = "Enter valid password.";
  } else if (!REGEX_PATTERN.test(value)) {
    errorStatus = true;
    errorMessage =
      "Password should be at least 12 characters long or maximum limit 16 characters with at least 1 uppercase letter, 1 special character and 1 number.";
  }
  return { errorStatus, errorMessage };
};

export const CONFIRM_PASSWORD = (password, value) => {
  let errorMessage = "";
  let errorStatus = false;
  if (password !== value) {
    errorStatus = true;
    errorMessage = "Passwords should match.";
  }
  return { errorStatus, errorMessage };
};

export const getUnit = (score, type) => {
  let unit;
  if (score != 0) {
    if (score >= 1000 && score <= 999999) {
      score = score / 1000;
      unit = "K";
    }
    // millions
    else if (score >= 1000000 && score <= 999999999) {
      score = score / 1000000;
      unit = "M";
    }
    // billions
    else if (score >= 1000000000 && score <= 999999999999) {
      score = score / 1000000000;
      unit = "B";
    }
    // not in above
    else {
      unit = "";
    }
  }
  if (type === "score") {
    return Math.floor(score) === score ? score : score.toFixed(2);
  }

  return {
    score: Number(score?.toFixed(2)),
    unit,
  };
};

export const SUBSCRIPTION = {
  FREE: "free",
  TRIAL: "trial",
  BASIC: "basic",
  LIMITED: "limitedpro",
  PRO: "pro",
  ANALYST: "analyst",
  CONSULTANT: "consultant",
};

export const CARD_NAME = {
  OPPORTUNITIE: "opportunities",
  BOOST_DEPOSIT: "secondary_consumer",
  GHOST_CONSUMER: "ghost_consumer",
  TOP_MERCHANT: "top_merchant",
};

export const OPPORTUNITIES = [
  {
    key: "credit_card",
    name: "Credit Card",
    icon: exportimages.icon_credit_card,
    color: "#27CAE3",
  },
  {
    key: "consumer_loan",
    name: "Consumer Loan",
    icon: exportimages.icon_consumer_loan,
    color: "#5CAEFF",
  },
  {
    key: "mortgage",
    name: "Mortgage",
    icon: exportimages.icon_mortgage,
    color: "#FE6682",
  },
  {
    key: "auto_loan",
    name: "Auto Loan",
    icon: exportimages.icon_auto_loan,
    color: "#6C7DE5",
  },
  {
    key: "student_loan",
    name: "Student Loan",
    icon: exportimages.icon_student_loan,
    color: "#FF6DE8",
  },
  {
    key: "personal_loan",
    name: "Personal Loan",
    icon: exportimages.icon_personal_loan,
    color: "#FFB30E",
  },
  {
    key: "business_loan",
    name: "Business Loan",
    icon: exportimages.icon_business_loan,
    color: "#A099F3",
  },
  {
    key: "commercial_loan",
    name: "Commercial Loan",
    icon: exportimages.icon_commercial_loan,
    color: "#3EE0D7",
  },
  {
    key: "deposit",
    name: "Deposit",
    icon: exportimages.icon_deposit,
    color: "#A099F3",
  },
  {
    key: "checking",
    name: "Checking Accounts",
    icon: exportimages.icon_checking,
    color: "#8577E6",
  },
];

export const CONSUMERS = [
  {
    key: "internal_deposits",
    name: "Internal Deposit Opportunity",
    icon: null,
    color: "#687AE5",
    bgColor: "",
  },
  {
    key: "external_deposits",
    name: "External Deposit Available",
    icon: null,
    color: "#45A1FF",
    bgColor: "",
  },
];

export const CONSUMERS_TYPES = [
  //Added record for depo purpose
  {
    key: "account_transfer",
    name: "Account Transfer",
    icon: exportimages.icon_account_transfer,
    coloured_icon: exportimages.icon_account_transfer_coloured,
    color: "#1570EF",
  },
  {
    key: "checking",
    name: "Checking Accounts (Demand Deposit Accounts, DDAs) ",
    icon: exportimages.icon_checking,
    coloured_icon: exportimages.icon_checking_coloured,
    color: "#8577E6",
  },
  {
    key: "savings",
    name: "Savings Accounts",
    icon: exportimages.icon_savings,
    coloured_icon: exportimages.icon_savings_coloured,
    color: "#EA80AE",
  },
  {
    key: "certificates_of_deposit",
    name: "Certificates of Deposit (CDs)",
    icon: exportimages.icon_certificates_of_deposit,
    coloured_icon: exportimages.icon_certificates_of_deposit_coloured,
    color: "#111f1dff",
  },
  {
    key: "ira",
    name: "IRA Savings",
    icon: exportimages.icon_ira,
    coloured_icon: exportimages.icon_ira_coloured,
    color: "#FFD77A",
  },
  {
    key: "health_savings_account",
    name: "Health Savings Account (HSA)",
    icon: exportimages.icon_health_savings_account,
    coloured_icon: exportimages.icon_health_savings_account_coloured,
    color: "#67A1E7",
  },
  {
    key: "529_education_accounts",
    name: "529 Education Accounts",
    icon: exportimages.icon_529_education_accounts,
    coloured_icon: exportimages.icon_529_education_accounts_coloured,
    color: "#B48DF2",
  },
  {
    key: "investment",
    name: "Investments",
    // filterKey: FILTER_KEYS.products,
    icon: exportimages.icon_investment,
    coloured_icon: exportimages.icon_investment_coloured,
    color: "#F79268",
  },
  {
    key: "general_transfer",
    name: "General Transfer",
    icon: exportimages.icon_general_transfer,
    coloured_icon: exportimages.icon_general_transfer_coloured,
    color: "#45BE8B",
  },
  {
    key: "person_to_person",
    name: "Person to Person",
    // filterKey: FILTER_KEYS.products,
    icon: exportimages.icon_person_to_person,
    coloured_icon: exportimages.icon_person_to_person_coloured,
    color: "#be56d6",
  },
  {
    key: "checking_account",
    name: "Checking account",
    // filterKey: FILTER_KEYS.products,
    icon: exportimages.icon_checking,
    coloured_icon: exportimages.icon_checking_coloured,
    color: "#8577E6",
  },
];

export const RESPONSE = {
  SUCCESS: {
    status_code: 200,
    status: "SUCCESS",
  },
  ERROR: {
    status: "ERROR",
  },
};

export const HASHTAGKEYARRAY = [
  {
    key: "AutopilotLoanOpportunities",
    url: (uid) => `/bank/health-analysis/report/${uid}`,
    cardID: "AutopilotProductOpportunities",
  },
  {
    key: "AutopilotDepositOpportunities",
    url: (uid) => `/bank/health-analysis/report/${uid}`,
    cardID: "AutopilotDepositOpportunities",
  },
];

const templates = JSON.parse(process.env.REACT_APP_CAMPAIGN_SAMPLE_TEMPLATES);

export const SAMPLE_TEMPLATES = [
  {
    sampleTemplateObj: [
      {
        id: templates[1],
        heading: "Ready to gain more!!",
        category: "Business Loan",
        src: "sample_template_one",
      },
      {
        id: templates[2],
        heading: "Escape High-Interest Rate",
        category: "Credit Card",
        src: "sample_template_two",
      },
      {
        id: templates[0],
        heading: "Binge your favourite Netflix for free.",
        category: "Savings Account",
        src: "sample_template_three",
      },
    ],
  },
];

export const PROXIMITY_STATES = [
  { name: "Alabama", key: "alabama" },
  { name: "Alaska", key: "alaska" },
  { name: "Arizona", key: "arizona" },
  { name: "Arkansas", key: "arkansas" },
  { name: "California", key: "california" },
  { name: "Colorado", key: "colorado" },
];

export const FI_TYPES = [
  { name: "Credit Union: Federal", key: "cu-f" },
  { name: "Credit Union: State", key: "cu-s" },
];

export const CHARTER_TYPES = [
  { name: "Industrial", key: "industrial" },
  { name: "Commercial", key: "commercial" },
];

export const Campaign_Statistics = [
  {
    key: "processed_Count",
    name: "Targeted Consumers",
    value: 0,
    icons: exportimages?.icon_users,
  },
  {
    key: "delivered_Count",
    name: "Emails Delivered",
    value: 0,
    icons: exportimages?.icon_ongoing_campaign,
  },
  {
    key: "opened_Count",
    name: "Emails Opened",
    value: 0,
    icons: exportimages?.icon_approved_campaign,
  },
  {
    key: "clicked_Count",
    name: "CTA Clicks",
    value: 0,
    icons: exportimages?.icon_ongoing_campaign,
  },
  {
    key: "bounced_Count",
    name: "Bounced Emails",
    value: 0,
    icons: exportimages?.icon_mail_block,
  },
  {
    key: "unsubscribed_Count",
    name: "Unsubscribes",
    value: 0,
    icons: exportimages?.icon_mail_fail,
  },
];

export const SMS_Campaign_Statistics = [
  {
    key: "processed_Count",
    name: "Targeted Consumers",
    value: 0,
    icons: exportimages?.icon_users,
  },
  {
    key: "sent_Count",
    name: "Messages Sent",
    value: 0,
    icons: exportimages?.icon_ongoing_campaign,
  },
  {
    key: "delivered_Count",
    name: "Messages Delivered",
    value: 0,
    icons: exportimages?.icon_approved_campaign,
  },
  {
    key: "undelivered_Count",
    name: "Failed Deliveries",
    value: 0,
    icons: exportimages?.icon_ongoing_campaign,
  },
  {
    key: "clicked_Count",
    name: "CTA Clicks",
    value: 0,
    icons: exportimages?.icon_mail_block,
  },
  {
    key: "unsubscribed_Count",
    name: "Unsubscribes",
    value: 0,
    icons: exportimages?.icon_mail_fail,
  },
];

export const FHS_SEGMENTS = [
  {
    key: "return_on_assets",
    title: "Return on Assets (ROA)",
    description: "Profitability in relation to total assets (YTD)",
    icon: exportimages.total_assets_icon,
    symbol: "%",
    is_reverse: "false",
  },
  {
    key: "return_on_equity",
    title: "Return on Equity (ROE)",
    description: "Profitability in relation to total equity (YTD)",
    icon: exportimages.deposit_growth_icon,
    symbol: "%",
    is_reverse: "false",
  },
  {
    key: "capital_adequacy_ratio",
    title: "Capital Adequacy Ratio (CAR)",
    description:
      "Percentage of financial institution's capital to its risk-weighted assets (YTD)",
    icon: exportimages.loan_growth_icon,
    symbol: "%",
    is_reverse: "false",
  },

  {
    key: "efficiency_ratio",
    title: "Efficiency Ratio",
    description: "Measures the financial institution's cost effectiveness",
    icon: exportimages.efficiency_ratio_icon,
    symbol: "%",
    is_reverse: "true",
  },
  {
    key: "net_interest_income",
    title: "Net Interest Income (NII)",
    description:
      "Reflects revenue generated from core lending and borrowing activities",
    icon: exportimages.net_interest_income_nii_icon,
    symbol: "$",
    is_reverse: "false",
  },
  {
    key: "net_interest_margin",
    title: "Net Interest Margin (NIM)",
    description:
      "Profitability by measuring the difference between interest income and expenses relative to earning assets",
    icon: exportimages.net_interest_margin_nim_icon,
    symbol: "%",
    is_reverse: "false",
  },
  {
    key: "non_interest_expense",
    title: "Non Interest Expense",
    description:
      "Represents operating costs that are separate from interest expenses",
    icon: exportimages.gross_npa_icon,
    symbol: "$",
    is_reverse: "true",
  },
  {
    key: "npa_to_total_loans_ratio",
    title: "NPA to Total Loans Ratio",
    description: "Reflects bad loans after recoveries and write-offs (YTD).",
    icon: exportimages.npa_to_total_loans_ratio_icon,
    symbol: "%",
    is_reverse: "true",
  },
];

export const FHS_SEGMENTS_ADDITIONAL_REGULARITY = [
  {
    key: "tier1_capital_ratio",
    title: "Tier 1 capital ratio",
    description:
      "Core equity vs. risk-weighted assets; measures financial strength.",
    icon: exportimages.tier_1_capital_ratio,
    symbol: "%",
    is_reverse: "false",
  },
  {
    key: "tier1_leverage_ratio",
    title: "Tier 1 leverage ratio",
    description: "Core capital vs. total assets; shows overall leverage.",
    icon: exportimages.tier_1_leverage_ratio,
    symbol: "%",
    is_reverse: "false",
  },
  {
    key: "npa_to_total_assets",
    title: "NPA to Total Assets",
    description: "Share of assets not earning income; indicates asset quality.",
    icon: exportimages.non_performing_asssets_to_total_assets,
    symbol: "%",
    is_reverse: "true",
  },
  {
    key: "loan_loss_reserve_to_total_loans_and_leases",
    title: "Loan Loss Reserve to Total Loans",
    description: "Reserves set aside to cover potential loan losses.",
    icon: exportimages.loan_loss_reserve_to_total_loans_and_leases,
    symbol: "%",
    is_reverse: "false",
  },
  {
    key: "classified_assets_ratio",
    title: "Classified Assets Ratio",
    description: "Proportion of risky or downgraded assets.",
    icon: exportimages.classified_assets_ratio,
    symbol: "%",
    is_reverse: "true",
  },
  {
    key: "net_liquidity_ratio",
    title: "Net Liquidity Ratio",
    description: "Liquid assets available to meet short-term obligations.",
    icon: exportimages.net_liquidity_ratio,
    symbol: "%",
    is_reverse: "false",
  },
  {
    key: "loan_to_deposit_ratio",
    title: "Loan to Deposit Ratio",
    description: "Measures how much lending is funded by deposits.",
    icon: exportimages.loan_to_deposit_ratio,
    symbol: "%",
    is_reverse: "true",
  },
  {
    key: "liquidity_coverage_ratio",
    title: "Liquidity Coverage Ratio",
    description: "Liquid assets held to survive a 30-day stress period.",
    icon: exportimages.liquidity_coverage_ratio,
    symbol: "%",
    is_reverse: "false",
  },
  {
    key: "net_long_term_assets_to_total_shares_and_borrowings",
    title: "Net Long-Term Assets to Total Shares & Borrowings",
    description: "Long-term assets funded by stable capital and borrowings.",
    icon: exportimages.liquidity_coverage_ratio,
    symbol: "%",
    is_reverse: "true",
  },
];

export const BPM_KEY = {
  client_uid: "client_uid",
  financial_institute: "financial_institute",
  financial_health_score: "financial_health_score",
  net_interest_income: "net_interest_income",
  earning_accretion: "earning_accretion",
  total_assets: "total_assets",
  total_loans: "total_loans",
  total_deposits: "total_deposits",
  asset_quality: "asset_quality",
};

export const BANK_PERFORMANCE_METRICS = [
  {
    key: BPM_KEY.client_uid,
    title: "Financial Institution",
    isVisable: false,
    sortable: false,
    colspan: 1,
  },
  {
    key: BPM_KEY.financial_institute,
    title: "Financial Institution",
    isVisable: true,
    width: 18,
    header_css: "sticky-left",
    class: "sticky-left",
    sortable: false,
    colspan: 1,
  },
  {
    key: BPM_KEY.financial_health_score,
    title: "Financial Performance Benchmark",
    // title: "Financial Health",
    is_reverse: "false",
    isVisable: true,
    width: 14,
    header_css: "text-center",
    sortable: true,
    colspan: 2,
    current_key: "financial_Health_Score",
    forecast_key: "financial_Health_Score_Next",
  },
  {
    key: BPM_KEY.net_interest_income,
    title: "Net Interest Income",
    is_reverse: "false",
    isVisable: true,
    symbol: "$",
    width: 14,
    header_css: "text-center",
    sortable: true,
    colspan: 2,
    current_key: "net_Interest_Income",
    forecast_key: "net_Interest_Income_Next",
  },
  {
    key: BPM_KEY.earning_accretion,
    title: "Earnings Accretion",
    is_reverse: "false",
    isVisable: true,
    symbol: "$",
    width: 14,
    header_css: "text-center",
    sortable: true,
    colspan: 2,
    current_key: "earning_Accretion",
    forecast_key: "earning_Accretion_Next",
  },
  {
    key: BPM_KEY.total_assets,
    title: "Total Assets",
    is_reverse: "false",
    isVisable: true,
    symbol: "$",
    width: 14,
    header_css: "text-center",
    sortable: true,
    colspan: 2,
    current_key: "total_Assets",
    forecast_key: "total_Assets_Next",
  },
  {
    key: BPM_KEY.total_loans,
    title: "Total Loans",
    is_reverse: "false",
    isVisable: true,
    symbol: "$",
    width: 14,
    header_css: "text-center",
    sortable: true,
    colspan: 2,
    current_key: "total_Loans",
    forecast_key: "total_Loans_Next",
  },
  {
    key: BPM_KEY.total_deposits,
    title: "Total Deposits",
    is_reverse: "false",
    isVisable: true,
    symbol: "$",
    width: 14,
    header_css: "text-center",
    sortable: true,
    colspan: 2,
    current_key: "total_Deposits",
    forecast_key: "total_Deposits_Next",
  },
  {
    key: BPM_KEY.asset_quality,
    title: "Asset Quality",
    is_reverse: "false",
    isVisable: false,
    width: 14,
    header_css: "text-center",
    sortable: true,
    colspan: 2,
    current_key: "asset_Quality",
    forecast_key: "asset_Quality_Next",
  },
];

export const BANK_PERFORMANCE_METRICS_OPTIONS = [
  {
    title: "All Institutions",
    isRegister: "",
    roles: [USER_TYPE.SUPER_ADMIN, USER_TYPE.RESELLER],
  },
  {
    title: "My Institutions",
    isRegister: "",
    roles: [USER_TYPE.SUPER_ADMIN, USER_TYPE.RESELLER],
  },
  {
    title: "Available Institutions",
    isRegister: false,
    roles: [USER_TYPE.SUPER_ADMIN, USER_TYPE.RESELLER],
  },
  {
    title: "Registered Institutions",
    isRegister: true,
    roles: [USER_TYPE.SUPER_ADMIN],
  },
];

export const SEGMENT_INFLUENCING_FACTOR = [
  {
    key: "total_assets",
    title: "Total Assets",
    description: "Combined value of all assets owned or controlled",
    icon: exportimages.return_on_equity,
    is_reverse: "false",
    symbol: "$",
  },
  {
    key: "total_loans",
    title: "Total Loans",
    description: "Combined value of all loans & leases",
    icon: exportimages.asset_ratio,
    is_reverse: "false",
    symbol: "$",
  },
  {
    key: "total_deposits",
    title: "Total Deposits",
    description: "Combined value of all deposits",
    icon: exportimages.net_operating_income,
    is_reverse: "false",
    symbol: "$",
  },
];

export const HEALTH_ANALYSIS_STATUS = [
  {
    STATUS: "DRAFT",
    PERCENTAGE: 0,
    MESSAGE: "Started Calculating Draft Bank Health Score",
  },
  {
    STATUS: "NEW",
    PERCENTAGE: 10,
    MESSAGE: "Started Calculating New Bank Health Score",
  },
  {
    STATUS: "DATA_INGESTION-START",
    PERCENTAGE: 10,
    MESSAGE: "Investigation File Uploaded",
  },
  {
    STATUS: "DATA_INGESTION-END",
    PERCENTAGE: 10,
    MESSAGE: "Investigation File Uploaded",
  },
  {
    STATUS: "DATA_VALIDATION-START",
    PERCENTAGE: 20,
    MESSAGE: "Validating File Uploaded",
  },
  {
    STATUS: "DATA_VALIDATION-END",
    PERCENTAGE: 20,
    MESSAGE: "Validating File Uploaded",
  },
  {
    STATUS: "DATA_ENRICHMENT-START",
    PERCENTAGE: 30,
    MESSAGE: "Enriching Uploaded Data",
  },
  {
    STATUS: "DATA_ENRICHMENT-END",
    PERCENTAGE: 40,
    MESSAGE: "Enriching Uploaded Data",
  },
  {
    STATUS: "DATA_SCORING-START",
    PERCENTAGE: 50,
    MESSAGE: "Scoring Uploaded Data",
  },
  {
    STATUS: "DATA_SCORING-END",
    PERCENTAGE: 50,
    MESSAGE: "Scoring Uploaded Data",
  },
  {
    STATUS: "DATA_ANALYSIS-START",
    PERCENTAGE: 60,
    MESSAGE: "Analysing Your Data",
  },
  {
    STATUS: "DATA_ANALYSIS-L1_CARD_DATA",
    PERCENTAGE: 60,
    MESSAGE: "Analysing Your Data Card",
  },
  {
    STATUS: "DATA_ANALYSIS-RUNNING_BALANCE",
    PERCENTAGE: 70,
    MESSAGE: "Analysing Your Running Balance",
  },
  {
    STATUS: "DATA_ANALYSIS-BOND_SCORE",
    PERCENTAGE: 80,
    MESSAGE: "Analysing Your Bond Score",
  },
  {
    STATUS: "DATA_ANALYSIS-PERSONA",
    PERCENTAGE: 90,
    MESSAGE: "Analysing Your Persona",
  },
  {
    STATUS: "Complete",
    PERCENTAGE: 100,
    MESSAGE: "Results are ready!",
  },
  {
    STATUS: "ERROR",
    PERCENTAGE: 0,
    MESSAGE: "Opps! Something Went Wrong!",
  },
];

export const getHealthAnalysisStatusList = () => {
  return HEALTH_ANALYSIS_STATUS.filter(
    (item) => item.PERCENTAGE > 0 && item.PERCENTAGE < 100,
  ).map((item) => item.STATUS);
};

export const getHealthAnalysisStatus = (status) => {
  return HEALTH_ANALYSIS_STATUS.filter((item) => item?.STATUS === status);
};

export const cohortObj = [
  {
    icon: "cohort_percentile",
    cohort_title: "Percentile",
    cohort_description:
      "Percentile represents the relative ranking of a bank's FHS within the selected cohort.",
  },
  {
    icon: "cohort_avg",
    cohort_title: "Cohort Average",
    cohort_description:
      "It is the mean Financial Health Score(FHS) of all banks in the selected cohort.",
  },
  {
    icon: "cohort_institution",
    cohort_title: "Institutions",
    cohort_description:
      "Institution count refers to the total number of banks included in the selected cohort",
  },
];

export const cohortDataTemplate = [
  {
    icon: exportimages?.cohort_percentile,
    cohort_title: "Percentile",
    cohort_description:
      "Represents a position within a cohort, indicating the percentage of values that fall below a specific score. Providing insights into relative standing or performance.",
    cohort_score: null,
    id: 1,
  },
  {
    icon: exportimages?.cohort_avg,
    cohort_title: "Cohort Average",
    cohort_description:
      "Represents the average Financial Health Score within a specified cohort, providing a summary measure of the group's overall financial health.",
    cohort_score: null,
    id: 2,
  },
  {
    icon: exportimages?.cohort_institution,
    cohort_title: "Institutions",
    cohort_description:
      "Represents the total number of financial institutions within the specified cohort, offering insight into the size and diversity of the group.",
    cohort_score: null,
    id: 3,
  },
];

export const fhsGaugeStatus = [
  {
    status: "good",
    description: "Your bank is doing well!",
  },
  {
    status: "optimal",
    description: "Your bank is at optimal performance!",
  },
  {
    status: "requires action",
    description: "Your bank requires action.",
  },
  {
    status: "needs attention",
    description: "Your bank needs some attention.",
  },
];

export const EWI_KEY = {
  early_warning_indicators: "early_warning_indicators",
  strategy_growth: "strategy_growth",
};

export const EWI_CONFIG = [
  {
    key: EWI_KEY.early_warning_indicators,
    //title: "Early Warning Indicators(EWI)",
    // filterArray: ["rationale"],
    filterArray: [
      "problem_summary",
      "rationale_summary",
      "recommendation",
      "expected_outcome",
    ],
  },
];

export const EWI_NOTIFICATION_STATUS = {
  NOT_EXIST: "orange",
  EXIST: "green",
  READ: "blank",
};

export const DISABLED_EWI_CONTENT = {
  content: (
    <>
      <h6
        className="mb-2 text-white text-start"
        style={{
          fontSize: "13px",
          fontWeight: "600",
        }}
      >
        Insights are being prepared!
      </h6>

      <p className="mb-0 text-start">
        Your personalized Insights are currently being prepared and will be
        available soon. We'll notify you as
        soon as they are ready.
      </p>
    </>
  ),
};

const EWI_KEYS = {
  TITLE: "title_name",
  PROBLEM_SUMMARY: "problem_summary",
  PROBLEM: "problem",
  CONSEQUENCE_SUMMARY: "rationale_summary",
  CONSEQUENCE: "rationale",
  RECOMMENDATION: "recommendation",
  EXPECTED_OUTCOME: "expected_outcome",
  DETAILED_ACTION_PLAN: "detailed_action_plan",
};

export const EWI_VIEW_INSIGHTS = {
  VIEW_SUMMARY: "summary",
  VIEW_DETAILS: "details",
  NEXT: "next",
  PREV: "prev",
};

const EWI_SUB_KEYS = {
  SHORT_TERM: "short_term",
  MID_TERM: "mid_term",
  LONG_TERM: "long_term",
};

export const EWI_SECTION_TYPE = {
  TitleSection: "title_type",
  ProblemSection: "problem_type",
  RecommendationSection: "recommendation_type",
};

export const EWI_CHATBOT_CONFIG = {
  EWI: {
    UI_STRUCTURE: [
      {
        key: EWI_KEYS.TITLE,
        title: "Title",
        type: EWI_SECTION_TYPE.TitleSection,
      },
      {
        key: EWI_KEYS.PROBLEM_SUMMARY,
        title: "Problem",
        dataKey: "Problem",
        icon: exportimages?.insights_icon_problem,
        type: EWI_SECTION_TYPE.ProblemSection,
        viewType: EWI_VIEW_INSIGHTS.VIEW_SUMMARY,
      },
      {
        key: EWI_KEYS.CONSEQUENCE_SUMMARY,
        title: "Consequence",
        dataKey: "Consequence",
        icon: exportimages?.insights_icon_rational,
        type: EWI_SECTION_TYPE.ProblemSection,
        viewType: EWI_VIEW_INSIGHTS.VIEW_SUMMARY,
      },
      {
        key: EWI_KEYS.RECOMMENDATION,
        title: "Recommendation",
        icon: exportimages?.insights_icon_recommendation_new,
        type: EWI_SECTION_TYPE.RecommendationSection,
        viewType: EWI_VIEW_INSIGHTS.VIEW_SUMMARY,
      },
      {
        key: EWI_KEYS.EXPECTED_OUTCOME,
        title: "Expected Outcome with Autopilot",
        icon: exportimages?.insights_icon_recommendation_new,
        type: EWI_SECTION_TYPE.RecommendationSection,
        viewType: EWI_VIEW_INSIGHTS.VIEW_SUMMARY,
      },
      {
        key: EWI_KEYS.PROBLEM,
        title: "Problem",
        dataKey: "Problem",
        icon: exportimages?.insights_icon_problem,
        type: EWI_SECTION_TYPE.ProblemSection,
        viewType: EWI_VIEW_INSIGHTS.VIEW_DETAILS,
      },
      {
        key: EWI_KEYS.CONSEQUENCE,
        title: "Consequence",
        dataKey: "Consequence",
        icon: exportimages?.insights_icon_rational,
        type: EWI_SECTION_TYPE.ProblemSection,
        viewType: EWI_VIEW_INSIGHTS.VIEW_DETAILS,
      },
      {
        key: EWI_KEYS.DETAILED_ACTION_PLAN,
        title: "Short-Term (0–6 months)",
        dataKey: "Short-Term (0–6 months)",
        icon: exportimages?.insights_icon_shortterm,
        type: EWI_SECTION_TYPE.ProblemSection,
        sub_type: EWI_SUB_KEYS?.SHORT_TERM,
        viewType: EWI_VIEW_INSIGHTS.VIEW_DETAILS,
      },
      {
        key: EWI_KEYS.DETAILED_ACTION_PLAN,
        title: "Mid-Term (6–12 months)",
        icon: exportimages?.insights_icon_midterm,
        type: EWI_SECTION_TYPE.ProblemSection,
        sub_type: EWI_SUB_KEYS?.MID_TERM,
        viewType: EWI_VIEW_INSIGHTS.VIEW_DETAILS,
      },
      {
        key: EWI_KEYS.DETAILED_ACTION_PLAN,
        title: "Long-Term (12+ months)",
        icon: exportimages?.insights_icon_longterm,
        type: EWI_SECTION_TYPE.ProblemSection,
        sub_type: EWI_SUB_KEYS?.LONG_TERM,
        viewType: EWI_VIEW_INSIGHTS.VIEW_DETAILS,
      },
    ],
  },
  CHATBOT: null,
};

export const EWI_CHATBOT_SUGGESTED_PROMPT = [
  {
    question:
      "How would a gradual Fed easing cycle affect the bank's NIM over 2026?",
  },
  {
    question:
      "Break down interest income and identify the fastest growing line items from last 3 years.",
  },
  {
    question: "Is the current deposit strategy improving funding stability?",
  },
];

export const BETA_VERSION_CONTENT = {
  // test: "This ChatBOT is currently in a beta version and is designed to perform best for queries related to loans, deposits, and profitability. A ChatBOT can make mistakes. Please do not share any confidential or sensitive information while interacting with the ChatBOT"
  test: "ARIA is currently in a beta and can make mistakes.",
};

export const EWI_CHATBOT_SIDEBAR_TOOLS = [
  {
    img: exportimages?.EWI_chatbot_tool_chatbot_logo,
    label: "ARIA",
    isHoverImg: true,
    isSidebarOpen: true,
  },
  {
    img: exportimages?.EWI_chatbot_tool_consultation,
    label: "Book a consultation",
    isHoverImg: false,
    isSidebarOpen: false,
  },
  {
    img: exportimages?.EWI_chatbot_tool_new_chat,
    label: "Start a New Chat",
    isHoverImg: false,
    isSidebarOpen: false,
  },
  {
    img: exportimages?.EWI_chatbot_tool_history,
    label: "History",
    isHoverImg: false,
    isSidebarOpen: true,
  },
  {
    img: exportimages?.EWI_chatbot_tool_deleted_chat,
    label: "Deleted Chats",
    isHoverImg: false,
    isSidebarOpen: true,
  },
];
export const AUTOMATED_CAMPAIGN_CONFIG = [
  {
    title: "Email Campaigns",
    img: exportimages?.scheduled_campaign_img,
    channel: "bondai_campaign_channel_email",
    status: ["status"],
    count: ["count"],
    privileges: PRIVILEGES.SHOW_EMAIL_CAMPAIGN_MANAGEMENT,
  },
  {
    title: "SMS Campaigns",
    img: exportimages?.scheduled_campaign_img,
    channel: "bondai_campaign_channel_sms",
    status: ["status"],
    count: ["count"],
    privileges: PRIVILEGES.SHOW_SMS_CAMPAIGN_MANAGEMENT,
  },
];

export const USER_NOTIFICATION_AARAY = [
  {
    key: "New Data Available",
    img: exportimages?.icon_new_analysis_complete,
  },
  {
    key: "Data Analysis Failed",
    img: exportimages?.icon_analysis_failed,
  },
];

export const EWI_LOCK_SCREEN_DATA = [
  {
    img: "",
    title: "Supercharge Your Growth",
    content:
      "Unlock advanced insights, smart recommendations, and faster growth.",
    buttonLabel: "",
  },
  {
    img: exportimages?.EWI_subscription_icon,
    title: "Unlock the Full Potential of Autopilot",
    content:
      "You’ve started strong — now go further with Pro. Get access to advanced analytics, personalized growth.",
    buttonLabel: "Upgrade to Autopilot Pro",
  },
];

export const EWI_Image_array = [
  {
    EWI_icon: exportimages?.EWI_icon_1,
  },
  {
    EWI_icon: exportimages?.EWI_icon_2,
  },
  {
    EWI_icon: exportimages?.EWI_icon_3,
  },
  {
    EWI_icon: exportimages?.EWI_icon_4,
  },
  {
    EWI_icon: exportimages?.EWI_icon_5,
  },
  {
    EWI_icon: exportimages?.EWI_icon_6,
  },
  {
    EWI_icon: exportimages?.EWI_icon_7,
  },
  {
    EWI_icon: exportimages?.EWI_icon_8,
  },
  {
    EWI_icon: exportimages?.EWI_icon_9,
  },
  {
    EWI_icon: exportimages?.EWI_icon_10,
  },
  {
    EWI_icon: exportimages?.EWI_icon_11,
  },
  {
    EWI_icon: exportimages?.EWI_icon_12,
  },
];

export const PDF_EWI_Image_array = [
  {
    EWI_icon: exportimages?.PDF_EWI_icon_1,
  },
  {
    EWI_icon: exportimages?.PDF_EWI_icon_2,
  },
  {
    EWI_icon: exportimages?.PDF_EWI_icon_3,
  },
  {
    EWI_icon: exportimages?.PDF_EWI_icon_4,
  },
  {
    EWI_icon: exportimages?.PDF_EWI_icon_5,
  },
  {
    EWI_icon: exportimages?.PDF_EWI_icon_6,
  },
  {
    EWI_icon: exportimages?.PDF_EWI_icon_7,
  },
  {
    EWI_icon: exportimages?.PDF_EWI_icon_8,
  },
  {
    EWI_icon: exportimages?.PDF_EWI_icon_9,
  },
  {
    EWI_icon: exportimages?.PDF_EWI_icon_10,
  },
  {
    EWI_icon: exportimages?.PDF_EWI_icon_11,
  },
  {
    EWI_icon: exportimages?.PDF_EWI_icon_12,
  },
];

export const ACTIVATE_USER_SCREEN_DATA = {
  success: {
    // INVITED FLOW
    img: exportimages.success_icon,
    title: "Verification Successful",
    content: `<p>Your account has been successfully verified.</br>We've sent your login credentials to your registered email address.</p>`,
    label: "What happens next",
    steps: [
      {
        icon: exportimages?.active_user_inbox,
        text: "Check your inbox for your login details",
      },
      {
        icon: exportimages?.active_user_secure_link,
        text: "Use the secure link to access your account",
      },
    ],
    addLoader: false,
    buttonLabel: "Go to Sign In",
    buttonLink: "/user/login",
  },
  signupSuccess: {
    // APPLIED FLOW (Self Signup)
    img: exportimages.success_icon,
    title: "Verification Successful",
    content: `<p>Your email has been verified.</br>You can now sign in using the email address and password you created during registration.</p>`,
    label: "What's next",
    steps: [
      {
        icon: exportimages?.RT_login_icon,
        text: "Sign in with your registered email",
      },
      {
        icon: exportimages?.active_user_secure_link,
        text: "Start using Autopilot",
      },
    ],
    addLoader: false,
    buttonLabel: "Go to Sign In",
    buttonLink: "/user/login",
  },

  fail: {
    img: exportimages.RT_fail_icon,
    title: "Verification unsuccessful",
    content: `<p>Something went wrong while verifying your account.</br>Please try again or check your details before retrying.</p>`,
    label: "What you can do",
    steps: [
      {
        icon: exportimages?.RT_retry_icon,
        text: "Retry the verification process",
      },
      {
        icon: exportimages?.RT_check_icon,
        text: "Double-check your information",
      },
      {
        icon: exportimages?.RT_contactSupport_icon,
        text: "Contact support if the issue persists",
      },
    ],
    addLoader: false,
    buttonLabel: "",
    buttonLink: "",
  },
  verify: {
    img: exportimages?.active_verification_account,
    title: "Verifying Your Account",
    content: `<p>We're currently verifying your account details.</br>This usually takes a few moments.</p><p>Once completed, we'll send your login credentials to your registered email address.</p>`,
    label: "What you can do",
    steps: [
      {
        icon: exportimages?.active_user_inbox,
        text: "Check your inbox for your login details",
      },
      {
        icon: exportimages?.active_not_received_email,
        text: "Didn't receive an email? Check your spam or junk folder",
      },
    ],
    addLoader: true,
    buttonLabel: "",
    buttonLink: "",
  },

  verifySignup: {
    img: exportimages?.active_verification_account,
    title: "Verifying Your Account",
    content: `<p>We're currently verifying your account details.</br>This usually takes a few moments.</p><p>Once completed, you'll be able to sign in using the email address and password you created during registration.</p>`,
    label: "What's next",
    steps: [
      {
        icon: exportimages?.RT_login_icon,
        text: "Sign in with your registered email",
      },
      {
        icon: exportimages?.active_not_received_email,
        text: "Please wait while your verification is completed",
      },
    ],
    addLoader: true,
    buttonLabel: "",
    buttonLink: "",
  },

  alreadyVerified: {
    img: exportimages.success_icon,
    title: "Account already verified",
    content: `<p>Your account has already been verified.</br>You can log in using your existing credentials. If you’ve forgotten your password, you can reset it anytime.</p>`,
    label: "What you can do",
    steps: [
      {
        icon: exportimages?.RT_login_icon,
        text: "Log in with your registered email and password",
      },
      {
        icon: exportimages?.RT_reset_passowrd_icon,
        text: "Reset your password if you’re unable to sign in",
      },
      {
        icon: exportimages?.RT_contactSupport_icon,
        text: "Contact support if the issue persists",
      },
    ],
    addLoader: false,
    buttonLabel: "Go to Sign In",
    buttonLink: "/user/login",
  },
  linkExpired: {
    img: exportimages.RI_link_expired_main_icon,
    title: "Activation Link Expired",
    content: `<p>This verification link has expired for security reasons.</br>Request a new verification email to continue setting up your account.</p>`,
    label: "What you can do",
    steps: [
      {
        icon: exportimages?.RT_verification_link_icon,
        text: "Request a new verification email",
      },
      {
        icon: exportimages?.RT_inbox_icon,
        text: "Check your inbox for the latest link",
      },
      {
        icon: exportimages?.RT_contactSupport_icon,
        text: "Ensure you use the link before it expires",
      },
    ],
    addLoader: false,
    buttonLabel: "",
    buttonLink: "",
  },
};
